import React from 'react'
import { AnnouncementManagementStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  Paginate,
  Section,
  Table,
  Input,
  InputSearch,
} from '../../components'
import { ICONS, CONTENTS } from '../../themes'
import { ROUTE_PATH, redirect, STRING } from '../../helpers'

export class AnnouncementManagementContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modals: [{ name: 'delete', isOpen: false, Idlist: '', Fullname: '' }],
      isSortBy: [
        { name: 'orderNumber', value: undefined },
        { name: 'title', value: undefined },
      ],
    }
  }

  toggleSort = evt => {
    this.setState(prevState => ({
      ...prevState,
      isSortBy: prevState.isSortBy.map(column => ({
        ...column,
        value:
          column.name === evt
            ? column.value !== undefined
              ? column.value === 'asc'
                ? 'desc'
                : 'asc'
              : 'asc'
            : undefined,
      })),
    }))
  }

  filterSortByValue = evt => {
    return this.state.isSortBy
      .filter(columns => columns.name === evt)
      .map(column => column.value)[0]
  }

  toggleModal = (evt, id, name) => {
    this.setState(prevState => ({
      ...prevState,
      modals: prevState.modals.map(modal => ({
        ...modal,
        isOpen: modal.name === id ? !modal.isOpen : false,
        Idlist: id,
        Fullname: name,
      })),
    }))
  }

  render() {
    const { modals } = this.state

    return (
      <React.Fragment>
        <AnnouncementManagementStyled>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_sustainability_pre_assessment_management"
                  src={ICONS['icon-speaker-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section
                  id="page_title_announcement_management"
                  className="title"
                >
                  {STRING.ANNOUNCEMENT_MANAGEMENT}
                </Section>

                <Section
                  id="page_breadcrumb_announcement_management"
                  className="breadcrumbs"
                >
                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.HOME}</span>
                  </Button>

                  <Button className="breadcrumb current">
                    <span>{STRING.ANNOUNCEMENT_MANAGEMENT}</span>
                  </Button>
                </Section>
              </Section>
            </Section>

            <Section className="page-button">
              <Button className="page-button" onClick={() => {}}>
                {/* <Image src={ICONS['icon-add-circular.svg']} alt="add icon" /> */}
                Create Announcement
              </Button>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="main-content">
            <Section className="content-body">
              <Section className="table-filter">
                <InputSearch
                  id="filter_search_input"
                  placeholder="Tax ID, Company Name"
                />
              </Section>

              <Section className="table-wrapper">
                <Table className="sustainability split-row-color">
                  {/* Header Row */}
                  <Table.THEAD>
                    <Table.TR className="header">
                      <Table.TH
                        className="order-number"
                        id="order_number_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('orderNumber')}
                        onClick={() => this.toggleSort('orderNumber')}
                      >
                        No.
                      </Table.TH>

                      <Table.TH
                        className="title"
                        id="title_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('title')}
                        onClick={() => this.toggleSort('title')}
                      >
                        TITLE
                      </Table.TH>

                      <Table.TH className="start-date" id="start_date_header">
                        START DATE
                      </Table.TH>

                      <Table.TH className="end-date" id="end_date_header">
                        END DATE
                      </Table.TH>

                      <Table.TH className="last-update" id="last_update_header">
                        LAST UPDATE
                      </Table.TH>

                      <Table.TH className="actions" id="actions_header">
                        ACTIONS
                      </Table.TH>
                    </Table.TR>
                  </Table.THEAD>

                  {/* Content Row */}
                  <Table.TBODY>
                    <Table.TR>
                      <Table.TD className="order-number">1</Table.TD>

                      <Table.TD className="title">Title_1</Table.TD>

                      <Table.TD className="start-date">
                        Oct 08, 2019 14:00
                      </Table.TD>

                      <Table.TD className="end-date">
                        Oct 08, 2019 14:00
                      </Table.TD>

                      <Table.TD className="last-update">
                        Oct 08, 2019 14:00
                      </Table.TD>

                      <Table.TD className="actions">
                        <Section>
                          <Button className="link" onClick={() => {}}>
                            <Image
                              className="delete-icon"
                              src={ICONS['icon-edit.svg']}
                              alt="edit"
                            />
                          </Button>

                          <Button
                            className="link"
                            onClick={() => this.toggleModal()}
                          >
                            <Image
                              className="delete-icon"
                              src={ICONS['icon-trash.svg']}
                              alt="delete"
                            />
                          </Button>
                        </Section>
                      </Table.TD>
                    </Table.TR>
                  </Table.TBODY>
                </Table>
              </Section>
            </Section>

            <Section className="content-footer">
              <Section className="showing-item">
                Showing 1 to 10 of 60 entries
              </Section>

              <Section className="paginate-wrapper">
                <Paginate
                  activePage={1}
                  itemsCountPerPage={10}
                  totalItemsCount={450}
                  pageRangeDisplayed={5}
                  // onChange={() => ({})}
                />

                <Section className="moveto-wrapper">
                  <Input
                    className="paginate-moveto"
                    label="Page"
                    defaultValue="1"
                    isHorizontal
                    maxLength="4"
                  />

                  <Button>go</Button>
                </Section>
              </Section>
            </Section>
          </Section>
        </AnnouncementManagementStyled>

        <Modal
          id="delete_id"
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'delete'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
        >
          <Modal.Header>Delete</Modal.Header>

          <Modal.Body>
            <p className="default text-center">
              Are you sure to delete? <br />
              {modals[0].FullName}
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray"
              onClick={() => this.toggleModal('delete')}
            >
              Cancel
            </Button>

            <Button
              id="close_modal_history_id"
              className="theme-green"
              onClick={() => {
                this.deleteList()
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}
